import { useTranslation } from 'react-i18next';
import LoadingButton from '@shared/components/LoadingButton';
import useFormHook from '@shared/hooks/useFormHook';
import { useState } from 'react';

export default function ErrorModal({ onClose, onSave, errorMessage }) {
    const { t } = useTranslation();
    const { modalRef } = useFormHook({}, onClose);
    const [loading, setLoading] = useState(false);

    const handleSave = async () => {
        if (onSave) {
            setLoading(true);
            try {
                await onSave();
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <div className="modal show" tabIndex="-1">
            <div className="modal-dialog modal-confirm" ref={modalRef}>
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="form-sections" style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="form-section" style={{ maxWidth: '500px', width: '100%' }}>
                                <div className="form-group">
                                    <p style={{ margin: '20px 0', wordWrap: 'break-word' }}>
                                        {errorMessage}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <LoadingButton 
                            type="button" 
                            className="btn btn-primary" 
                            loading={loading}
                            onClick={handleSave}
                        >
                            {t('common.save')}
                        </LoadingButton>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

